import React, { FormEvent, memo, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { SVGIcon } from ".";
import { Link, NavLink, useHistory } from "react-router-dom";
import { getQuery } from "../../utils/helpers";

interface Props {
  handleLogout: () => void;
  isLoggingOut: boolean;
}
const DashboardHeader = memo((props: Props) => {
  const history = useHistory();
  const currSearch = getQuery().get('search');

  const searchRef = useRef<HTMLInputElement>(null);
  function handleSubmitSearch(evt: FormEvent<HTMLFormElement>) {
    evt.preventDefault();
    const currCategory = getQuery().get("category");
    const val = searchRef.current?.value as string;
    if (val.trim()) {
      history.push(
        currCategory
          ? `/dashboard?category=${currCategory}&search=${val}`
          : `/dashboard?search=${val}`
      );
    } else if (window.location.pathname === "/dashboard") {
      history.push(
        currCategory ? `/dashboard?category=${currCategory}` : `/dashboard`
      );
    }
  }
  return (
    <header className="dashboard-header">
      <Navbar expand="md">
        <Link to="/dashboard" className="navbar-brand">
          <SVGIcon id="#logo" className="dashboard-header__logo" />
          لوحة التحكم
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="dashboard-navbar-nav">
          <form className="dashboard-header__search-form" onSubmit={handleSubmitSearch}>
            <input
              className="form-control"
              type="search"
              placeholder="البحث"
              aria-label="Search"
              defaultValue={currSearch || undefined}
              ref={searchRef}
            />
          </form>
          <div className="dashboard-header__btn-group">
            <NavDropdown title="متقدم" id="dashboard-nav-dropdown">
              <NavLink className="dropdown-item" to="/dashboard/admins">
                مشرفو الموقع
              </NavLink>
              <NavLink className="dropdown-item" to="/dashboard/categories">
                التخصصات
              </NavLink>
              <NavLink className="dropdown-item" to="/dashboard/areas">
                المناطق
              </NavLink>
              <NavLink className="dropdown-item" to="/dashboard/cities">
                المدن
              </NavLink>
            </NavDropdown>
            <div className="divider"></div>
            <button
              className="btn btn-link nav-item"
              onClick={props.handleLogout}
            >
              تسجيل الخروج
              {props.isLoggingOut ? (
                <SVGIcon id="#spinner" className="loading-icon icon" />
              ) : (
                <SVGIcon id="#logout" />
              )}
            </button>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
});

export default DashboardHeader;
